.AccountLayoutNav {
  flex-wrap: wrap;
}
